import Vue from 'Vue';

function Broadcast() {
    this.on = this.$on;
    this.off = this.$off;
    this.emit = this.$emit;
}
Broadcast.prototype = new Vue();
export default new Broadcast();


// WEBPACK FOOTER //
// ./src/tools/broadcast.js